module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/componentes/enviar-sms/enviar-sms.component.scss
// module id = ./src/app/shared/componentes/enviar-sms/enviar-sms.component.scss
// module chunks = main